export const paths = {
  root: 'clients',

  clients: {
    root: '/clients',
    details: (id: string | number) => `/clients/${id}`
  },
  products: {
    root: '/products',
    configMedical: `/products/config-medical`,
    configAccident: `/products/config-accident`,
    configCasco: `/products/config-casco`,
    configProperty: `/products/config-property`,
    configCmr: `/products/config-cmr`,
    configFinancial: `/products/config-financial`,
    configGuarantees: `/products/config-guarantees`
  },
  orders: {
    root: '/orders',
    details: (id: string | number) => `/orders/${id}`
  },
  invoices: {
    root: '/invoices'
  },
  financial: {
    root: '/financial',
    bankTransfer: '/financial/bank-transfer',
    installments: '/financial/installments',
    overdueInstallments: '/financial/overdue-installments'
  },
  transactions: {
    root: '/transactions'
  },
  externalApis: {
    root: '/external-apis'
  },
  statistics: {
    root: '/statistics'
  },
  settings: {
    root: '/settings',
    general: '/settings/general',
    ecec: '/settings/ecec',
    request1CLogs: {
      root: '/settings/request-1c-logs',
      details: (id: string | number) => `/settings/request-1c-logs/${id}`
    },
    requestEcecLogs: {
      root: '/settings/request-ecec-logs',
      details: (id: string | number) => `/settings/request-ecec-logs/${id}`
    }
  },
  nomenclatures: {
    root: '/nomenclatures',
    vehicleSettingsBrands: '/nomenclatures/vehicle-settings',
    vehicleSettingsModels: '/nomenclatures/vehicle-settings/models',
    colors: '/nomenclatures/vehicle-settings/colors',
    reserveTypes: '/nomenclatures/reserve-types',
    repairStations: '/nomenclatures/repair-stations'
  },
  salesPanel: {
    root: '/sales-panel',
    healthInsurance: {
      root: '/sales-panel/health-insurance',
      edit: (id: string | number) => `/sales-panel/health-insurance/edit/${id}`,
      reject: (id: string | number) =>
        `/sales-panel/health-insurance/reject/${id}`,
      dataEntry: (id: string | number) =>
        `/sales-panel/health-insurance/data-entry/${id}`
    },
    accidentInsurance: {
      root: '/sales-panel/accident-insurance',
      edit: (id: string | number) =>
        `/sales-panel/accident-insurance/edit/${id}`,
      reject: (id: string | number) =>
        `/sales-panel/accident-insurance/reject/${id}`,
      dataEntry: (id: string | number) =>
        `/sales-panel/accident-insurance/data-entry/${id}`
    },
    cascoInsurance: {
      root: '/sales-panel/casco',
      edit: (id: string | number) => `/sales-panel/casco/edit/${id}`,
      reject: (id: string | number) => `/sales-panel/casco/reject/${id}`,
      dataEntry: (id: string | number) => `/sales-panel/casco/data-entry/${id}`
    },
    propertyInsurance: {
      root: '/sales-panel/property',
      dataEntry: (id: string | number) =>
        `/sales-panel/property/data-entry/${id}`,
      edit: (id: string | number) => `/sales-panel/property/edit/${id}`,
      reject: (id: string | number) => `/sales-panel/property/reject/${id}`
    },
    cmrInsurance: {
      root: '/sales-panel/cmr',
      edit: (id: string | number) => `/sales-panel/cmr/edit/${id}`,
      dataEntry: (id: string | number) => `/sales-panel/cmr/data-entry/${id}`,
      reject: (id: string | number) => `/sales-panel/cmr/reject/${id}`
    },
    greenCardInsurance: {
      root: '/sales-panel/green-card',
      dataEntry: (id: string | number) =>
        `/sales-panel/green-card/data-entry/${id}`
      // edit: (id: string | number) => `/sales-panel/green-card/edit/${id}`,
      // reject: (id: string | number) => `/sales-panel/green-card/reject/${id}`
    },
    rcaInsurance: {
      root: '/sales-panel/rca',
      dataEntry: (id: string | number) => `/sales-panel/rca/data-entry/${id}`
    },
    financialInsurance: {
      root: '/sales-panel/financial-risk',
      dataEntry: (id: string | number) =>
        `/sales-panel/financial-risk/data-entry/${id}`
    },
    guaranteesInsurance: {
      root: '/sales-panel/guarantees',
      dataEntry: (id: string | number) =>
        `/sales-panel/guarantees/data-entry/${id}`
    }
  },
  companiesManagement: {
    root: '/companies-management'
  },
  paymentsConfig: {
    root: '/payments-config',
    cashBoxes: '/payments-config/cash-boxes'
  },
  staff: {
    root: '/staff',
    agents: '/staff/agents',
    teams: '/staff/teams'
  },
  rcaDocuments: {
    root: '/rca-documents',
    details: (id: string | number) => `/rca-documents/${id}`
  },
  rcaGreenCardDocuments: {
    root: '/rca-green-card-documents',
    details: (id: string | number) => `/rca-green-card-documents/${id}`
  },
  rcaCanceledDocuments: {
    root: '/rca-canceled-documents'
  },
  rcaGreenCardCanceledDocuments: {
    root: '/rca-green-card-canceled-documents'
  },
  rcaSyncJobs: {
    root: '/rca-sync-jobs',
    details: (id: string | number) => `/rca-sync-jobs/${id}`
  },
  reports: {
    root: '/reports',
    healthInsuranceContractsRegister:
      '/reports/health-insurance-contracts-register',
    detailsHealthInsuranceContractsRegister: (id: string | number) =>
      `/reports/health-insurance-contracts-register/${id}`,
    accidentInsuranceContractsRegister:
      '/reports/accident-insurance-contracts-register',
    detailsAccidentInsuranceContractsRegister: (id: string | number) =>
      `/reports/accident-insurance-contracts-register/${id}`,
    cascoInsuranceContractsRegister:
      '/reports/casco-insurance-contracts-register',
    detailsCascoInsuranceContractsRegister: (id: string | number) =>
      `/reports/casco-insurance-contracts-register/${id}`,
    propertyInsuranceContractsRegister:
      '/reports/property-insurance-contracts-register',
    detailsPropertyInsuranceContractsRegister: (id: string | number) =>
      `/reports/property-insurance-contracts-register/${id}`
  },
  bankSummary: {
    root: '/bank-summary',
    rca: '/bank-summary/rca',
    greenCard: '/bank-summary/green-card',
    medical: '/bank-summary/medical',
    accidents: '/bank-summary/accidents',
    casco: '/bank-summary/casco',
    property: '/bank-summary/property',
    financial: '/bank-summary/financial',
    guarantees: '/bank-summary/guarantees'
  },
  claims: {
    root: '/claims',
    notifications: '/claims/notifications',
    notificationsDetails: (id: string | number) =>
      `/claims/notifications/${id}`,
    newNotifications: '/claims/notifications/new',
    files: '/claims/case-rca',
    filesDetails: (id: string | number) => `/claims/case-rca/${id}`,
    newFiles: '/claims/case-rca/new',
    casesRcae: '/claims/case-rcae',
    casesRcaeDetails: (id: string | number) => `/claims/case-rcae/${id}`,
    newCasesRcae: '/claims/case-rcae/new'
  }
}
